import { useMemo } from 'react';

export type HighLightTextProps = {
  text: string;
  highlight: string;
  enableHighLight: boolean;
};
const HighLightText = ({ text, highlight, enableHighLight }: HighLightTextProps) => {
  const displayedText = useMemo(() => {
    if (enableHighLight && highlight) {
      const textSplit = text.split(
        new RegExp(`\\b${highlight.toLowerCase().split(' ').join('|\\b')}`, 'gi')
      );

      const suggestionHighLighted = textSplit
        .map((element: string) => element.trim())
        .filter((element) => element !== '');

      const regex = new RegExp(
        `${suggestionHighLighted
          .map((term) => term.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
          .join('\\b|')}\\b`,
        'gi'
      );

      return (
        <span
          dangerouslySetInnerHTML={{
            __html: text.replace(regex, (match) => `<strong>${match}</strong>`),
          }}
        />
      );
    }

    // Split text on highlight term, include term itself into parts, ignore case
    return text;
  }, [text, enableHighLight, highlight]);

  return <>{displayedText}</>;
};

export default HighLightText;
